export enum ImageUploadType {
  MEMORANDUM = "MEMORANDUM",
  MY_LOGO = "MY_LOGO",
  SPECIFIC_LOGO = "SPECIFIC_LOGO",
}
